export interface ASRItem {
  flow: string
  message: string
  timestamp: number
  sliceType: number
  index: number
}

export interface CallInfo {
  calleeLocation?: string
  calleePhoneNumberText?: string
  callerPhoneNumberText?: string
  callTimestamp?: number
  calleeName?: string
  leadId?: number
  cid?: string
  recordId?: number
}

export type CallStatusString = 'idle' | 'calling' | 'talking'

export enum AIAssistantSopNodeType {
  branch = 'branch',
  task = 'task',
}
export interface AIAssistantSopNode {
  id: string
  name: string
  type: AIAssistantSopNodeType
  words: string
  keywords: string
  childrenTitle?: string
  label?: string
  children?: AIAssistantSopNode[]
}

export interface CustomerProfile {
  componentName: string
  data: {
    actNum: string
    adoption: string
    branchNum: string
    companyName: string
    custIndustry1Name: string
    isChina500:string
    isIpo:string
    isProv100: string
    leadId: string
    prodClass4NameCombo: string
    registerCap: string
    stateOwnedEntrpr: string
  }
}
export interface IntentionSummary {
  componentName: string
  data: {
    intentionSummary: {
      'customerName': string,
      'position': string,
      'needProduct': string,
      'budget': string,
      'competitors': string,
      'businessDemand': string,
      'projectPhases': string,
      'businessMatchmaking': string,
      'industry': string,
      'monthConsumption': string,
      'contactPosition': string
    }}
}

export interface AIAssistantSearchNode {
  id: string
  label: string
  words: string
  done?: boolean
}

export enum AIAssistantNodeType {
  assistant = 'assistant',
  aiSearch = 'aiSearch',
}

export interface AIAssistantNode {
  id: string
  type: AIAssistantNodeType
  node: AIAssistantSopNode | AIAssistantSearchNode
}
